import { cn } from '@/utils/cn';

type IProps = {
  name: string;
  className?: string;
  icon?: React.ReactNode;
  maxWidth?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  loading?: boolean;
  isDisabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
};

const Button: React.FC<IProps> = ({
  name,
  className,
  icon,
  maxWidth,
  onClick,
  loading,
  isDisabled,
  type = 'button',
}) => {
  return (
    <button
      type={type}
      className={cn(
        `flex w-full items-center justify-center border px-8 py-3 text-base ${maxWidth}`,
        className === 'black'
          ? 'bg-black text-white transition-all duration-300 hover:border-black hover:bg-transparent hover:text-black dark:hover:border-white dark:hover:bg-slate-300'
          : className === 'border'
            ? 'border-black bg-none text-black transition-all duration-300 hover:bg-black hover:text-white'
            : 'border-black bg-clr-20 text-white transition-all duration-300 hover:bg-transparent hover:text-black dark:hover:bg-slate-300',
        loading ? 'cursor-not-allowed opacity-50' : '',
        'disabled:border-gray-400 disabled:bg-gray-400 disabled:text-gray-700',
      )}
      onClick={onClick}
      disabled={loading || isDisabled}
    >
      {loading ? (
        <div className="h-5 w-5 animate-spin rounded-full border-4 border-t-4 border-transparent border-t-clr-0a" />
      ) : (
        <>
          {icon && <span className="mr-2">{icon}</span>}
          {name}
        </>
      )}
    </button>
  );
};

export default Button;
